import { render, staticRenderFns } from "./CreateNewProductType.vue?vue&type=template&id=6353247c&scoped=true&"
import script from "./CreateNewProductType.vue?vue&type=script&lang=js&"
export * from "./CreateNewProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6353247c",
  null
  
)

export default component.exports